import axios from 'axios';
import { CONFIG_URL, CONFIG_LOG_URL } from 'api/constants';
import { createErrorFromAxiosMultipleErrors } from 'api/utilities';

export async function getMokaConfig() {
  try {
    return await axios.get(CONFIG_URL);
  } catch (error) {
    throw createErrorFromAxiosMultipleErrors(error);
  }
}

export async function updateMokaConfig(payload) {
  try {
    return await axios.patch(CONFIG_URL, payload);
  } catch (error) {
    throw createErrorFromAxiosMultipleErrors(error);
  }
}

export async function getMokaConfigLogs(params) {
  try {
    return await axios.get(CONFIG_LOG_URL, { params });
  } catch (error) {
    throw createErrorFromAxiosMultipleErrors(error);
  }
}
